import { Pipe, PipeTransform } from '@angular/core';
import { DatosCiudades } from 'src/app/business/interfaces/configuraciones';

@Pipe({
  name: 'filtrarCiudades'
})
export class FiltrarCiudadesPipe implements PipeTransform {

  transform(data: DatosCiudades[], paisKey: keyof DatosCiudades, provinceKey: keyof DatosCiudades, paisValue?: keyof DatosCiudades, provincValue?: keyof DatosCiudades): DatosCiudades[] {
    return data.filter(lugar => {
      if (paisValue && !provincValue) {
        return lugar[paisKey] === paisValue;
      }

      if (paisValue && provincValue) {
        return lugar[paisKey] === paisValue && lugar[provinceKey] === provincValue;
      }

      return true;
    });
  }

}
